import create from "zustand";
import { persist } from "zustand/middleware";

const userStore = create(
  persist(
    (set, get) => ({
      isLoginRequired: false,
      setisLoginRequired: (status: boolean) => {
        set({ isLoginRequired: status });
      },
      user: undefined,
      redirectUrlPath: undefined,
      getUser: () => {
        const pStore: any = get();
        return pStore.user;
      },
      setUser: (newUser: any) => {
        set({ user: newUser });
      },
      facilities: [],
      setFacilities: (facilities: any[]) => {
        set({ facilities });
      },
      getFacilities: () => {
        const pStore: any = get();
        return pStore.facilities;
      },
      reset: () => {
        set({});
      },
    }),
    {
      name: "user-storage-v1.1", // Change upon deployment to clear userStore for users
    }
  )
);

export default userStore;